/**
 * EAkte Plus API
 * API eakteplus document metadata api
 *
 * OpenAPI spec version: 1.0.0
 * Contact: ehgidencores@eulerhermes.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * filter operation for number document metadata
 */
export type FilterDocumentMetadataNumberOperationEnum = 'EQUAL' | 'NOT_EQUAL' | 'LESS' | 'LESS_OR_EQUAL' | 'GREATER' | 'GREATER_OR_EQUAL' | 'BETWEEN' | 'NOT_BETWEEN';

export const FilterDocumentMetadataNumberOperationEnum = {
	EQUAL: '=' as FilterDocumentMetadataNumberOperationEnum,
	NOT_EQUAL: '!=' as FilterDocumentMetadataNumberOperationEnum,
	LESS: '<' as FilterDocumentMetadataNumberOperationEnum,
	LESS_OR_EQUAL: '<=' as FilterDocumentMetadataNumberOperationEnum,
	GREATER: '>' as FilterDocumentMetadataNumberOperationEnum,
	GREATER_OR_EQUAL: '=>' as FilterDocumentMetadataNumberOperationEnum
};
